export default __webpack_public_path__ + "static/9384ccfd30053991fedbf8fea8e46d4c.png";